import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import { connect } from "react-redux";

import ReactTable from "react-table";

import loaderIcon from "assets/img/loader.gif";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// import IconButton from "@material-ui/core/IconButton";
import green from "@material-ui/core/colors/green";
// import Icon from "@material-ui/core/Icon";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";

import DeleteModel from "components/Common/FevoModels/DeleteModel";

import axios from "../../../config/axios";

import toastr from "toastr";

import { getAllUsers$ } from "../../../redux/actions/user";

const formStyle = {
  minWidth: "100%",
  margin: "0 1.2rem 1.2rem 0"
};

class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      userTobeChangedIndex: null,
      userTobeChange: null,
      showBlockUserModal: false,
      showUnblockUserModal: false,
      userData: [],
      search_user_by_name: null,
      search_user_by_email: null,
      search_user_by_phone: null
    };
  }

  componentDidMount() {
    this.props.handleGetUsersList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.userListData !== prevProps.userListData) {
      // debugger;
      if (this.props.userListData.data.length > 0) {
        this.setState({ userData: this.props.userListData.data });
      } else {
        this.setState({ userData: [] });
      }
    }
  }

  getUserTableColumn = () => {
    // const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green
      }
    });
    let column = [
      {
        Header: "Customer Name",
        accessor: "name"
      },
      {
        Header: "Email",
        accessor: "email"
      },
      {
        Header: "Organization",
        accessor: "organisation"
      },
      {
        Header: "Industry",
        accessor: "industry"
      },
      {
        Header: "Designation",
        accessor: "designation"
      },
      {
        Header: "Contact No.",
        accessor: "mobile",
        sortable: false,
        Cell: data => {
          return data.original.extension + " " + data.original.mobile
        }
      },
      {
        Header: "Block/Unblock",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: user => {
          return (
            <div className="actions-center">
              <Switch
                checked={user.original.active}
                color='primary'
                onClick={e => {
                  e.stopPropagation();
                  this.handleUserStatusChange(user.original, user.index);
                }}
              />
            </div>
          );
        }
      }
    ];
    return column;
  };

  handleUserStatusChange = (userTobeChange, userTobeChangedIndex) => {
    if (userTobeChange.active) {
      this.setState({
        userTobeChange,
        userTobeChangedIndex,
        showBlockUserModal: true
      });
    } else {
      this.setState({
        userTobeChange,
        userTobeChangedIndex,
        showUnblockUserModal: true
      });
    }
  };

  changeUserStatus = (user, index) => {
    const body = { active: !user.active };
    axios
      .patch(`users/${user.id}/status`, body)
      .then(res => {
        if (res.status === 200) {
          if (user.active) {
            toastr.success("User Blocked Successfully!");
            this.handleBlockModal();
          } else {
            toastr.success("User Unblocked Successfully!");
            this.handleUnblockModal();
          }
          this.props.handleGetUsersList();
        }
      })
      .catch(error => toastr.error("Something wrong happened!"));
  };

  handleBlockModal = () => {
    this.setState(({ showBlockUserModal }) => ({
      showBlockUserModal: !showBlockUserModal,
      userTobeChangedIndex: null,
      userTobeChange: null
    }));
  };

  handleUnblockModal = () => {
    this.setState(({ showUnblockUserModal }) => ({
      showUnblockUserModal: !showUnblockUserModal,
      userTobeChangedIndex: null,
      userTobeChange: null
    }));
  };
  pageChange=()=>{
    let node = document.getElementById("event_main_page");
    if (node){
      node.scrollTop = 0
    }
  }
  render() {
    const {
      showBlockUserModal,
      showUnblockUserModal,
      userData,
      search_user_by_name,
      search_user_by_email,
      search_user_by_phone
    } = this.state;
    const { userListData, classes } = this.props;
    const { loading, data } = userListData;
    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} alt="loader"/>
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody className="row_design">
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <TextField
                        id="standard-search"
                        label="Search User by name"
                        name="search_user_by_name"
                        type="search"
                        fullWidth
                        value={search_user_by_name}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState(
                            {
                              userData: data
                            },
                            () => {
                              const newList = this.state.userData.filter(item =>
                                item.name
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );
                              this.setState({
                                userData: newList,
                                search_user_by_name: value.toLowerCase()
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                      <TextField
                        id="standard-search"
                        label="Search User by Email"
                        name="search_user_by_email"
                        type="search"
                        fullWidth
                        value={search_user_by_email}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState(
                            {
                              userData: data
                            },
                            () => {
                              const newList = this.state.userData.filter(item =>
                                item.email
                                  .toLowerCase()
                                  .includes(value.toLowerCase())
                              );
                              this.setState({
                                userData: newList,
                                search_user_by_email: value.toLowerCase()
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                      <TextField
                        id="standard-search"
                        label="Search User by Contact No."
                        name="search_user_by_phone"
                        type="search"
                        fullWidth
                        value={search_user_by_phone}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState(
                            {
                              userData: data
                            },
                            () => {
                              const newList = this.state.userData.filter(
                                item => {
                                  if (item.mobile) {
                                    return item.mobile
                                      .toLowerCase()
                                      .includes(value.toLowerCase());
                                  }
                                }
                              );
                              this.setState({
                                userData: newList,
                                search_user_by_phone: value.toLowerCase()
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>
                    <ReactTable
                      data={userData}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={25}
                      pageSizeOptions={[25, 50, 100]}
                      showPaginationBottom={true}
                      minRows={0}
                      noDataText="No users found!"
                      onPageChange={this.pageChange}
                      onPageSizeChange={this.pageChange}
                      getTrProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            cursor: "pointer"
                          }
                        };
                      }}
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px"
                          }
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <DeleteModel
              showModel={showBlockUserModal}
              title={"Are you sure you want to block this user?"}
              onCancel={this.handleBlockModal}
              onOk={() => {
                let { userTobeChangedIndex, userTobeChange } = this.state;
                this.changeUserStatus(userTobeChange, userTobeChangedIndex);
              }}
            />
            <DeleteModel
              showModel={showUnblockUserModal}
              title={"Are you sure you want to unblock this user?"}
              onCancel={this.handleUnblockModal}
              onOk={() => {
                let { userTobeChangedIndex, userTobeChange } = this.state;
                this.changeUserStatus(userTobeChange, userTobeChangedIndex);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userListData: state.users
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetUsersList: () => dispatch(getAllUsers$.trigger())
  };
};

const ManageUsersListComponent = withStyles(extendedTablesStyle)(ManageUsers);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageUsersListComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/UserManagement/index.js